module.exports = __webpack_public_path__ + "static/scale-model-of-cardboard-hill-in-chattanooga-tennessee-59c59b4555e65a12a45b69338ad68e1c.png";